<template>
    <div class="data-policy-page">
        <div class="container">
            <div class="page-title" v-if="!isMobileChecker">
                <h1>{{ dataPolicyPage.page_title }}</h1>
            </div>
            <div class="data-policy-pic">
                <div class="pic-item" :style="!isMobileChecker ? 'background-image: url(' + dataPolicyPage.img_banner + ')' : 'background-image: url(' + dataPolicyPage.img_banner_mobile + ')'"></div>
                <h2>{{ dataPolicyPage.title_banner }}</h2>
            </div>
            <div class="page-title-mobile" v-if="isMobileChecker">
                <h1>{{ dataPolicyPage.page_title }}</h1>
            </div>
            <div class="data-policy-desc" v-html="dataPolicyPage.policy_desc"></div>
        </div>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import formPage from '@/components/forms/form-page.vue'
    export default {
        name: 'data-policy--page',
        components: {
            formPage,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Политика конфиденциальности',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
                currentRoute: this.$router.history.current.path,
            }
        },
        computed: mapGetters({
            dataPolicyPage: 'loadDataPolicyPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.dataPolicyPage != null) {
                next();
                // next(vm => {
                //     // vm.$store.commit('removePageLoaderImg');
                //     setTimeout(() => {
                //         vm.$parent.$refs.topProgress.done();
                //     }, 300);
                // });
            } else {
                store.dispatch('getDataPolicyPageData').then((response) => {
                    if (response) {
                        next();
                        // next(vm => {
                        //     // vm.$store.commit('removePageLoaderImg');
                        //     setTimeout(() => {
                        //         vm.$parent.$refs.topProgress.done();
                        //     }, 300);
                        // });
                    } else {
                        next(false);
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'data-policy';
        },
        created () {
        },
        mounted() {
            // window.addEventListener("scroll", this.handleScroll);
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/data-policy-page/data-policy-page.scss';
    @import '@/styles/components/data-policy-page/data-policy-page-respond.scss';
    // @import '@/styles/components/about-page/respond/about-page-respond.scss';
</style>